// Types
import { RELOADED_VARIANTS } from '@kubit/web-ui-product-components';
import { SnackbarMessageType } from '@kubit/web-ui-components';
const getSnackbarConfigurations = (props) => ({
    ...props,
    description: { content: props?.description },
    title: { content: props.title },
    type: props?.type ?? SnackbarMessageType.INFORMATIVE,
    variant: props?.variant ?? RELOADED_VARIANTS.SnackbarVariant.SIMPLE,
});
export { getSnackbarConfigurations };
//# sourceMappingURL=snackbar.configurations.js.map